export { default } from './useLazyRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useLazyRef/index.js
// module id = 1742
// module chunks = 25